import { DocumentServicesObject } from '@wix/document-services-types';

import { RouterWithRequiredData } from '../../../../../types/unifiedComponents';
import {
  createUnifiedComponentsInstallationError,
  UnifiedComponentsInstallationErrorCode as ErrorType,
} from '../errors';
import { getValidRouterPrefix } from './routerPrefixResolver';
import { validateRouterPrefix } from './validations';

export function ensureValidRouterPrefix({
  appDefinitionId,
  documentServices,
  router,
}: {
  appDefinitionId: string;
  documentServices: DocumentServicesObject;
  router: RouterWithRequiredData;
}): string {
  const { errorCode, valid } = validateRouterPrefix(
    documentServices,
    appDefinitionId,
    router.data.preferredPrefix,
  );

  if (valid) {
    return router.data.preferredPrefix;
  }

  const resolvedPrefix = getValidRouterPrefix(
    documentServices,
    appDefinitionId,
    router.data.preferredPrefix,
    Number(errorCode),
  );

  if (!resolvedPrefix) {
    throw createUnifiedComponentsInstallationError(
      ErrorType.addingUnifiedComponentFailed,
      `Failed to add '${router.data.preferredPrefix}' router, prefix "${router.data.preferredPrefix}" is not valid`,
    );
  }

  return resolvedPrefix;
}
